import { faCopy } from "@fortawesome/pro-regular-svg-icons/faCopy";
import * as React from "react";

import { MprcIconFa, MprcIconFaProps } from "../MprcIconFa";

export const IconCopy: React.FC<Omit<MprcIconFaProps, "icon">> = (props) => {
    return <MprcIconFa {...props} icon={faCopy} />;
};
